import { useEffect, useState } from "react";

import { APIResponse } from "psims/models/api/response";
import { getRecordResults, MaybeMsoRefinerSubmission } from "psims/models/submission-types/mso/mso-refiner-submission";
import useServiceMessages from "../../shared/use-service-messages";
import { UseSubmit } from "../../shared/use-submit";
import { UseMsoRefinerForm } from "./use-mso-refiner-form";
import { UseMsoRefinerProgress } from "./use-mso-refiner-progress";
import { SubmissionStatus } from "../../shared/api";
import { attemptScrollToSelector } from "psims/react/pages/primary-pages/data-submissions/shared/view-utils";
import { SELECTOR_NOTIFICATIONS } from "psims/constants/selectors";

interface UseMsoRefinerServiceMessagesProps {
    formCtrl: UseMsoRefinerForm;
    progressCtrl: UseMsoRefinerProgress;
    serverError: unknown;
    submissionStatus: SubmissionStatus;
    submitCtrl: UseSubmit;
    updateResponse: APIResponse<MaybeMsoRefinerSubmission> | null;
}

function useMsoRefinerServiceMessages({formCtrl, progressCtrl, serverError, submissionStatus, submitCtrl, updateResponse}: UseMsoRefinerServiceMessagesProps) {
    const serviceMessages = useServiceMessages({extractRecordResults: getRecordResults, response: updateResponse, responseStatus: submissionStatus, serverError});
    const [exposedMessages, setExposedMessages] = useState(serviceMessages);

    useEffect(() => {
        setExposedMessages(serviceMessages);
    }, [serviceMessages]);

    useEffect(() => {
        setExposedMessages([]);
    }, [formCtrl.changeSerial, progressCtrl.currentStep.index, submitCtrl.changeSerial]);

    useEffect(() => {
        if (exposedMessages.length > 0) {
            attemptScrollToSelector(SELECTOR_NOTIFICATIONS);
        }
    }, [exposedMessages.length]);

    return exposedMessages;
}

export default useMsoRefinerServiceMessages
